import { ReactNode } from "react";
import { Box, AccordionSummary, AccordionDetails, Accordion, Chip } from "@mui/material";
import { IconCaret } from "src/components/icons-mui/caret";
import { Typography } from "src/components-mui/base/typography/typography";

interface IFilterCategoryItemProps {
    children: ReactNode;
    title: string;
    badgeInfo?: string;
}

export const FilterCategoryItem = ({ children, title, badgeInfo }: IFilterCategoryItemProps) => {
    return (
        <Accordion
            sx={{
                border: "none",
                px: 3,
                backgroundColor: "white",
            }}
        >
            <AccordionSummary
                expandIcon={<IconCaret />}
                sx={{
                    py: 3,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Typography sx={{ alignSelf: "center", fontSize: "md", fontWeight: "semibold" }}>{title}</Typography>
                    {badgeInfo && <Chip label={badgeInfo} variant="filled" color="blackAlpha" size="medium" sx={{ ml: 1 }} />}
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 1, pb: 3 }}>{children}</AccordionDetails>
        </Accordion>
    );
};
